export default __webpack_public_path__ + "static/wu-a247edd7b239e6bdab068e028e15ea83.png";